import { render, staticRenderFns } from "./inversores.vue?vue&type=template&id=8a136a5e"
import script from "./inversores.vue?vue&type=script&lang=js"
export * from "./inversores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports